import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { capitalize } from '@material-ui/core/utils';
import useStyles from './styles';
import type { OverridableStatusDot, StatusDotProps } from './types';

const StatusDot = forwardRef(function StatusDot<C extends React.ElementType>(
    props: StatusDotProps<C, { component?: C }>,
    ref: React.ComponentPropsWithRef<C>,
): JSX.Element {
    const { className, component: Component = 'div', label, color, size, ...rest } = props;
    const classes = useStyles();
    type TClasses = keyof typeof classes;

    return (
        <Component
            {...rest}
            ref={ref}
            className={clsx(
                classes.root,
                { [classes[`color${capitalize(color as string)}` as TClasses]]: color !== 'default' },
                { [classes[`size${capitalize(size as string)}` as TClasses]]: size !== 'medium' },
                className,
            )}
        >
            {label}
        </Component>
    );
});

StatusDot.defaultProps = {
    color: 'default',
    size: 'medium',
};

export type { StatusDotProps };
export default StatusDot as OverridableStatusDot;
